import { BUSINESS_LINE_FOR_PRICING_MODEL } from 'constants/price-rating';
import { TFunction } from 'i18next';
import { BusinessLineResponseDtoNameEnum } from 'libs/pinnacle-sdk';

export interface SubmissionDetailsTabProps {
  activeTab: string;
  onTabChange: (key: string) => void;
  businessLine: BusinessLineResponseDtoNameEnum;
}

export enum ESubmissionDetailsTabsKeys {
  LayerStructures = 'layer-structures',
  SubLimits = 'sub-limits',
  BasisOfCover = 'basis-of-cover',
}

export const getTabs = (
  businessLine: BusinessLineResponseDtoNameEnum,
  t: TFunction
) => [
  {
    key: ESubmissionDetailsTabsKeys.LayerStructures,
    label: t('submissionDetails.tabs.layerStructures'),
    disabled: false,
  },
  {
    key: ESubmissionDetailsTabsKeys.SubLimits,
    label: t('submissionDetails.tabs.subLimits'),
    disabled: !BUSINESS_LINE_FOR_PRICING_MODEL.includes(businessLine),
  },
  {
    key: ESubmissionDetailsTabsKeys.BasisOfCover,
    label: t('submissionDetails.tabs.basisOfCover'),
    disabled: !BUSINESS_LINE_FOR_PRICING_MODEL.includes(businessLine),
  },
];
